import { useState } from "react";
import CaseNoDailyOrder from "./tabs-daily-home/CaseNoDailyOrder";
import DiaryNoDailyOrder from "./tabs-daily-home/DiaryNoDailyOrder";
import IaOrderDailyOrder from "./tabs-daily-home/IaOrderDailyOrder";

const DrtDailyOrderParentHome = () => {
  const [relatedLink, setRelatedLink] = useState("DiaryNoDailyOrder");
  return (
    <>
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 tab-one p-0">
        <ul
          className="nav toptab-one mb-3 inner-tab mx-0"
          id="pills-tab"
          role="tablist"
        >
          <li className="nav-item">
            <a
              className={
                relatedLink === "DiaryNoDailyOrder"
                  ? "nav-link active"
                  : "nav-link"
              }
              id="inner-tab2"
              data-toggle="pill"
              // href="#pills-cause"
              role="tab"
              aria-controls="pills-cause"
              aria-selected="false"
              onClick={() => setRelatedLink("DiaryNoDailyOrder")}
            >
              Diary No.
            </a>
          </li>
          <li className="nav-item">
            <a
              className={
                relatedLink === "CaseNoDailyOrder"
                  ? "nav-link active"
                  : "nav-link"
              }
              id="inner-tab1"
              data-toggle="pill"
              // href="#pills-home"
              role="tab"
              aria-controls="pills-home"
              aria-selected="true"
              onClick={() => setRelatedLink("CaseNoDailyOrder")}
            >
              Case No.
            </a>
          </li>
          <li className="nav-item">
            <a
              className={
                relatedLink === "IaOrderDailyOrder"
                  ? "nav-link active"
                  : "nav-link"
              }
              id="inner-tab3"
              data-toggle="pill"
              // href="#pills-order"
              role="tab"
              aria-controls="pills-order"
              aria-selected="false"
              onClick={() => setRelatedLink("IaOrderDailyOrder")}
            >
              IA Order
            </a>
          </li>
        </ul>

        <div className="tab-content" id="pills-tabContent">
          {relatedLink === "CaseNoDailyOrder" ? (
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              // aria-labelledby="pills-home-tab"
            >
              <CaseNoDailyOrder />
            </div>
          ) : relatedLink === "DiaryNoDailyOrder" ? (
            <div
              className="tab-pane fade show active"
              id="pills-cause"
              role="tabpanel"
              // aria-labelledby="pills-profile-tab"
            >
              <DiaryNoDailyOrder />
            </div>
          ) : (
            <div
              className="tab-pane fade show active"
              id="pills-order"
              role="tabpanel"
              // aria-labelledby="pills-profile-tab"
            >
              <IaOrderDailyOrder />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DrtDailyOrderParentHome;
